__turbopack_context__.v({
  "checkbox": "alerts-module-scss-module__E8v6mG__checkbox",
  "dayWeek": "alerts-module-scss-module__E8v6mG__dayWeek",
  "footer": "alerts-module-scss-module__E8v6mG__footer",
  "inlineBlock": "alerts-module-scss-module__E8v6mG__inlineBlock",
  "itemAlerts": "alerts-module-scss-module__E8v6mG__itemAlerts",
  "selectDaysOfWeek": "alerts-module-scss-module__E8v6mG__selectDaysOfWeek",
  "strong": "alerts-module-scss-module__E8v6mG__strong",
  "timeSelect": "alerts-module-scss-module__E8v6mG__timeSelect",
  "wrpSelect": "alerts-module-scss-module__E8v6mG__wrpSelect",
});
